<render-slice
  *ngFor="let slice of slices; trackBy: trackBySlice"
  [attr.data-id]="slice ? slice.id : null"
  [slice]="slice"></render-slice>
